import React from "react";

import ReactDOM from "react-dom/client";
import "./styles/index.scss";
import App from "./App";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";
// import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrBfoqqtScOFXXFZxkWoh0Xey2MvQlzWs",
  authDomain: "deliciousfood-120a1.firebaseapp.com",
  projectId: "deliciousfood-120a1",
  storageBucket: "deliciousfood-120a1.firebasestorage.app",
  messagingSenderId: "667032169105",
  appId: "1:667032169105:web:d25725306b66bddc556d30",
  measurementId: "G-QDHHQB8D03",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);
